// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as TableDefault } from '../../../assets/icons/default/layout/table.svg?react';
import { ReactComponent as TableExtended } from '../../../assets/icons/extended/entities/table.svg?react';
import { ReactComponent as TableSolid } from '../../../assets/icons/solid/layout/TABLE.svg?react';
import { createIcons } from '../../Icon';
const TableIcon = /* @__PURE__ */ createIcons('Table', {
    default: TableDefault,
    extended: TableExtended,
    solid: TableSolid
});
TableIcon.supportedTypes = ['default', 'extended', 'solid'];
TableIcon.category = 'layout';
export default TableIcon;
